const PrintActions = {
    LAUNCH_DIALOG: "print/launch-dialog",
};

export default PrintActions;



// WEBPACK FOOTER //
// ./app/lib/dataentry/lib/print/PrintActions.js